import React, { useContext, useState } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  MenuItem,
  Sidenav,
  AppStoreContainer,
} from 'pages/sidebar/SideBar.style';
import { useSelector } from 'react-redux';
import { AuthContext } from 'router/AuthProvider';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';
import { Modal } from 'components';
import { swipeModalWidth } from 'utils/helper';
import useWindowDimensions from 'components/Dimention';

import AppStoreLight from 'assert/images/Navbar/appStoreLight.png';
import AppStoreDark from 'assert/images/Navbar/appStoreDark.png';
import { ReactComponent as WafyNetLogo } from 'assert/images/Common/wafynetLogo.svg';
import { ReactComponent as Home } from 'assert/images/Navbar/home.svg';
import { ReactComponent as Work } from 'assert/images/Navbar/work.svg';
import { ReactComponent as Assistant } from 'assert/images/Navbar/assistant.svg';
import { ReactComponent as Notification } from 'assert/images/Navbar/notification.svg';
import { ReactComponent as UserProfile } from 'assert/images/Navbar/userProfile.svg';
import { ReactComponent as Network } from 'assert/images/Navbar/network.svg';
import { ReactComponent as Settings } from 'assert/images/Navbar/settings.svg';
import { ReactComponent as Phone } from 'assert/images/Navbar/phone.svg';
import { ReactComponent as AndroidStore } from 'assert/images/Navbar/androidStore.svg';
import { ReactComponent as AppleStore } from 'assert/images/Navbar/appleStore.svg';

import { ReactComponent as HomeFilled } from 'assert/images/Navbar/homeFilled.svg';
import { ReactComponent as WorkFilled } from 'assert/images/Navbar/workFilled.svg';
import { ReactComponent as AssistantFilled } from 'assert/images/Navbar/assistantFilled.svg';
import { ReactComponent as NotificationFilled } from 'assert/images/Navbar/notificationFilled.svg';
import { ReactComponent as UserProfileFilled } from 'assert/images/Navbar/userProfileFilled.svg';
import { ReactComponent as NetworkFilled } from 'assert/images/Navbar/networkFilled.svg';
import { ReactComponent as SettingsFilled } from 'assert/images/Navbar/settingsFilled.svg';
import { Capacitor } from '@capacitor/core';

const Sidebar = ({ notificationCount }) => {
  const { t } = useTranslation();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const windowLocation = window.location.pathname;
  const { isLoggedIn } = useContext(AuthContext);
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;
  const mode = localStorage.getItem('mode');
  const appStoreImg = mode === 'Dark' ? AppStoreDark : AppStoreLight;

  const [openModal, setOpenModal] = useState(false);

  const MenuList = [
    {
      icon: <Home />,
      filledIcon: <HomeFilled className="home-filled" />,
      title: 'Home',
      path: '/',
      activePath: ['/post-history', '/post-details', '/following'],
      exactPath: ['/'],
    },
    {
      icon: <Work />,
      filledIcon: <WorkFilled />,
      title: 'Job',
      path: '/jobs',
      activePath: ['/postjob'],
      exactPath: ['/jobs'],
    },
    {
      icon: <Assistant />,
      filledIcon: <AssistantFilled />,
      title: 'BusinessHub',
      path: '/business-hub',
      activePath: ['/business-hub'],
    },
    {
      icon: <Network />,
      filledIcon: <NetworkFilled />,
      title: 'Network',
      path: '/network/suggestions',
      activePath: ['/network'],
    },
    {
      icon: <UserProfile />,
      filledIcon: <UserProfileFilled />,
      title: 'Profile',
      path: `/profile/${getProfile?.username}`,
      activePath: [
        '/profile',
        '/jobs/applied-list',
        '/jobs/job-post',
        '/home',
        '/resume',
      ],
    },
    {
      icon: <Notification />,
      filledIcon: <NotificationFilled />,
      title: 'Notification',
      path: '/notification',
      activePath: ['/notification'],
    },
    {
      icon: <Settings />,
      filledIcon: <SettingsFilled />,
      title: 'Settings',
      path: '/settings',
      activePath: ['/settings'],
    },
    {
      icon: <Phone />,
      filledIcon: <Phone />,
      title: 'Download',
      path: '/share',
      activePath: [],
    },
  ];

  const getContent = () => {
    return (
      <AppStoreContainer>
        <div className="appstore-download-container">
          <div>
            <div className="company-brand">
              <WafyNetLogo />
              <div className="logo-title">WafyNet</div>
            </div>
            <div className="appstore-helper-text">Download from app stores</div>
          </div>
          <AppleStore className="appstore-download-img" />
          <AndroidStore
            className="appstore-download-img"
            onClick={() =>
              window.open(
                'https://play.google.com/store/apps/details?id=com.wafynet.myapp&pcampaignid=web_share',
                '_blank',
                'noopener,noreferrer'
              )
            }
          />
        </div>
        <div className="appstore-img-container">
          <img className="appstore-img" src={appStoreImg} />
        </div>
      </AppStoreContainer>
    );
  };

  return (
    <>
      <Sidenav>
        <div className="sidenav-container">
          <MenuItem>
            {(isLoggedIn ? MenuList : MenuList.slice(0, 3)).map(
              (data, index) => {
                const isPathInclude = data.activePath.find((path) =>
                  windowLocation.startsWith(path)
                );
                const isExactPath = data.exactPath?.find(
                  (path) => windowLocation === path
                );
                if (data.path === '/share' && Capacitor.isNativePlatform())
                  return null;
                return (
                  <Link
                    key={index}
                    to={data.path === '/share' ? '#' : data.path}
                    onClick={(e) => {
                      if (data.path === '/share') {
                        e.preventDefault();
                        setOpenModal(true);
                      }
                    }}
                    className={clsx(
                      'menu-list',
                      isPathInclude || isExactPath ? 'active-menu' : ''
                    )}
                  >
                    {isPathInclude || isExactPath ? data.filledIcon : data.icon}
                    {data.title === 'Notification' &&
                    notificationCount?.count ? (
                      <span className="notification-count">
                        {notificationCount?.count}
                      </span>
                    ) : (
                      <></>
                    )}
                    <div>
                      {(!isLoggedIn && data.title === 'Home' && 'Explore') ||
                        t(`HomePage.${data.title}`)}
                    </div>
                  </Link>
                );
              }
            )}
          </MenuItem>
        </div>
      </Sidenav>
      {isSmallScreen ? (
        <SwipeableEdgeDrawer
          openDrawer={openModal}
          handleCloseDrawer={() => setOpenModal(false)}
        >
          {getContent()}
        </SwipeableEdgeDrawer>
      ) : (
        <Modal
          modalchanges="appstoreModal"
          content={getContent()}
          openModal={openModal}
          handleCancelModal={() => setOpenModal(false)}
        />
      )}
    </>
  );
};

export default Sidebar;
